import { render, staticRenderFns } from "./feature-quote.vue?vue&type=template&id=7a3f7190&scoped=true&"
import script from "./feature-quote.vue?vue&type=script&lang=js&"
export * from "./feature-quote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3f7190",
  null
  
)

export default component.exports